import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import type { CoachComment as CoachCommentType } from '@/lib/types';
import IsNewCommentIndicator from '@/components/comment/IsNewCommentIndicator';
import StyledComment from './styled-components/StyledComment';
import CoachCommentAuthor from './CoachCommentAuthor';
import CommentHeader from './styled-components/CommentHeader';
import HtmlRenderer from '../../TypeSpecificFieldRenderers/utils/HtmlRenderer';
import Space from '@/components/Space';
import { useContext, useState } from 'react';
import CoachCommentEditor from './CoachCommentEditor';
import CommentActionButton from './styled-components/CommentActionButton';
import { Edit as EditIcon } from '@mui/icons-material';
import DeleteCoachComment from './DeleteCoachComment';
import CoachCommentsContext from '../CoachCommentsContext';

type CoachCommentProps = {
  coachComment: CoachCommentType;
};

const CoachComment = ({ coachComment }: CoachCommentProps) => {
  const { isInLogEntry } = useContext(CoachCommentsContext);

  const [editing, setEditing] = useState(false);

  return (
    <StyledComment isInLogEntry={isInLogEntry}>
      <CommentHeader>
        {coachComment.author !== null && (
          <CoachCommentAuthor
            author={coachComment.author}
            commentCreatedAt={coachComment.createdAt}
          />
        )}
        <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
          {!coachComment.isRead && <IsNewCommentIndicator />}
        </RestrictedToPortfolioMode>
        <RestrictedToPortfolioMode mode={PortfolioMode.COACH}>
          <Space width="auto" />
          <CommentActionButton onClick={() => setEditing(true)}>
            <EditIcon fontSize="small" />
          </CommentActionButton>
          <DeleteCoachComment coachComment={coachComment} />
        </RestrictedToPortfolioMode>
      </CommentHeader>
      {editing ? (
        <CoachCommentEditor
          coachComment={coachComment}
          onClose={() => setEditing(false)}
        />
      ) : (
        <HtmlRenderer source={coachComment.content} />
      )}
    </StyledComment>
  );
};

export default CoachComment;
